import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  setSelectedUserAction,
  userState,
} from "../../app/reducers/user-slice";
import { useDeleteUserMutation } from "../../query/user-query";
import theme from "../../style/theme";
import { ITEM_NUMBER_BY_PAGE } from "../../types/pages";
import { AppViewMode } from "../../types/user/app-view-mode";
import { Role } from "../../types/user/role";
import { DeleteButton } from "../button/DeleteButton";
import { profileState } from "../../app/reducers/profile-slice";

interface Props {
  role: Role;
}

export const UserListTable: React.FC<Props> = ({ role }) => {
  const dispatch = useAppDispatch();
  const { selectedUser, userPage } = useAppSelector(userState);
  const { profile } = useAppSelector(profileState);
  const deleteUserMutation = useDeleteUserMutation();

  let tableHeaders = ["번호", "이름", "전화번호", "생년월일", "앱 표기", "소속", ""];

  if (profile?.company.name !== "SUPERUSER") {
    tableHeaders = tableHeaders.filter(h => h !== "소속")
  }

  const handleClickProUserDeleteButton = async (id: string) => {
    if (window.confirm("정말로 삭제하시겠습니까?")) {
      deleteUserMutation.mutate(id);
    } else {
      alert("취소되었습니다.");
    }
  };

  const handleClickTableRow = (
    event: React.MouseEvent<HTMLTableRowElement>
  ) => {
    const selectedUser = userPage.contents.find(
      (user) => user.id === event.currentTarget.id
    );

    if (!selectedUser) {
      return;
    }

    dispatch(setSelectedUserAction({ selectedUser }));
  };

  // TODO
  // const handleClickProUserInfoButton = async (id: string) => {
  //   try {
  //     copyClipboardJson(response.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const getProRoleLabel = (proRole: ProRole) => {
  //   switch (proRole) {
  //     case ProRole.Advanced:
  //       return "선별";
  //     default:
  //       return "일반";
  //   }
  // };

  // const getProRoleColor = (proRole: ProRole) => {
  //   switch (proRole) {
  //     case ProRole.Advanced:
  //       return "red";
  //     default:
  //       return "green";
  //   }
  // };

  return (
    <ProUserTableContainer>
      <ProUserTable>
        {tableHeaders.map((tableHeader) => (
          <ProUserTableHeader>{tableHeader}</ProUserTableHeader>
        ))}

        <ProUserTableBody>
          {userPage.contents.map((user, index) => {
            if (!user) {
              return null;
            }

            const isSelected = user.id === selectedUser?.id;
            return (
              <ProUserTableRow
                key={user.id}
                id={user.id}
                isSelected={isSelected}
                onClick={handleClickTableRow}
              >
                <ProUserTableData>
                  {index + 1 + userPage.page * ITEM_NUMBER_BY_PAGE}
                </ProUserTableData>
                <ProUserNameTableData>
                  <ProUserTableDataLabel>{user.name}</ProUserTableDataLabel>
                </ProUserNameTableData>
                <ProUserTableData>
                  <ProUserTableDataLabel>{user.phone}</ProUserTableDataLabel>
                </ProUserTableData>
                <ProUserTableData>
                  <ProUserTableDataLabel>{user.birth}</ProUserTableDataLabel>
                </ProUserTableData>
                <ProUserTableData>
                  <ProUserTableDataLabel>
                    {user.appViewMode === AppViewMode.Onggoing
                      ? "B2B(개별 촬영)"
                      : "B2C(묶음 촬영/QR)"}
                  </ProUserTableDataLabel>
                </ProUserTableData>
                {profile?.company.name === "SUPERUSER" && (
                    <ProUserTableData>
                      <ProUserTableDataLabel>
                        {user.company.name}
                      </ProUserTableDataLabel>
                    </ProUserTableData>
                )}

                <ProUserTableData>
                  <DeleteButton
                    value={user.id}
                    onClick={(
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ) => {
                      event.stopPropagation();
                      handleClickProUserDeleteButton(user.id);
                    }}
                  />

                  {/* <button
                    onClick={() =>
                      handleClickProUserInfoButton(proUser.id)
                    }
                  ></button> */}
                </ProUserTableData>
              </ProUserTableRow>
            );
          })}
        </ProUserTableBody>
      </ProUserTable>
    </ProUserTableContainer>
  );
};

const ProUserTableContainer = styled.div`
  //height: 541px;
  min-height: 0;
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 61vw;
  border-radius: 4px;
  word-break: break-all;
`;
const ProUserTable = styled.table`
  width: 100%;
  overflow: hidden;
  table-layout: fixed;
`;
const ProUserTableHeader = styled.th`
  height: 3.188rem;
  text-align: center;
  vertical-align: middle;
  background-color: ${theme.palette.primitives.gray50};
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.gray600};
  padding: 0 0.625rem;

  &:first-of-type {
    padding-left: 0px;
  }
  &:nth-last-of-type(1) {
    padding-right: 0px;
  }
`;
const ProUserTableBody = styled.tbody``;

interface ProUserTableRowProps {
  isSelected?: boolean;
}

const ProUserTableRow = styled.tr<ProUserTableRowProps>`
  height: 3.063rem;
  border-bottom: ${`1px solid ${theme.palette.primitives.gray100}`};
  background-color: ${(props) =>
    props.isSelected
      ? `${theme.palette.primitives.gray50}`
      : `${theme.palette.primitives.white}`};
  cursor: pointer;

  :hover {
    // background-color: ${theme.palette.primitives.gray50};
    background-color: #f5f6f980;
  }
`;

const ProUserTableData = styled.td`
  padding: 6px 0px;
  text-align: center;
  vertical-align: middle;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray600};
  padding: 0 0.625rem;

  &:first-of-type {
    padding-left: 0px;
  }
  &:nth-last-of-type(1) {
    padding-right: 0px;
  }
`;

const ProUserNameTableData = styled.td`
  padding: 6px 0px;
  text-align: center;
  vertical-align: middle;
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.063rem;
  color: ${theme.palette.primitives.gray900};
  padding: 0 0.625rem;
`;

const ProUserTableDataLabel = styled.div`
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
`;
